import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(
    public afs: AngularFirestore,   
    ) { }

  getSessionDates() {
    return this.afs.collection('digital_sessions', ref => ref.where('date', '>', new Date())).get().toPromise()
  }
  getSessionBookings() {
    let date = new Date('2023-12-12');
    return this.afs.collection('session_bookings', ref => ref.where('date', '>', date)).get().toPromise()
  }
  createSessionBooking(doc){
    const userID = JSON.parse(localStorage.getItem('user')).uid;
    doc.uid = userID;
    return this.afs.collection('session_bookings').add(doc);
  }
}
